/**
 * Shared mutation-scope id for mutations against a given proposal. Mutations
 * that share a scope id run in series (TanStack Query), so rapid selection
 * toggles apply in order instead of racing each other's optimistic writes and
 * follow-up refetches.
 */
export const proposalMutationScopeId = (proposalId: string) =>
  `proposalMutations:${proposalId}`;
